<template>
  <v-card>
    <v-card-title>
      <div class="text-h6 align-baseline text-center full-width">
        <strong>Create an Event</strong>
        <v-btn icon class="close-button elevation-0" @click="cancelDialog">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
        <v-divider class="my-2"></v-divider>
      </div>
    </v-card-title>
    <v-card-text>
      <v-form class="mx-2">
        <v-row>
          <v-col cols="12">
            <v-text-field
              autofocus
              label="Event name"
              v-model="eventName"
              required
              :rules="[() => !!eventName || 'An entry is required']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              clearable
              :items="items"
              item-text="name"
              item-value="id"
              chips
              deletable-chips
              clear-icon="mdi-close-circle"
              multiple
              label="Categories"
              v-model="selectedCategories"
              hide-selected
              :search-input.sync="search"
              @change="search = ''"
              return-object
              hint="Select categories to add to this Event."
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <p>
                        No Category matching "
                        <strong>{{ search }}</strong>
                        ".
                      </p>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="{ attr, on, item, index, selected }">
                <v-chip
                  v-bind="attr"
                  :input-value="selected"
                  color="#78909C"
                  class="white--text"
                  v-on="on"
                  close
                  @click:close="selectedCategories.splice(index, 1)"
                >
                  <span v-text="item.name"></span>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-avatar
                  color="#78909c"
                  class="text-h5 font-weight-light white--text"
                >
                  {{ item.name.charAt(0) }}
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="item.symbol"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="pa-4 justify-end">
      <v-btn
        color="primary"
        @click="submitChanges"
        :disabled="!(selectedCategories.length && eventName)"
      >
        <v-progress-circular
          v-if="isSubmitting"
          class="mr-3"
          indeterminate
          :size="20"
          :width="1"
          color="secondary"
        ></v-progress-circular>
        Create
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";

import { treeBuildCatList } from "../../../utils/treeUtils";

export default {
  props: {
    selectedRecord: Object,
    tree: Object,
  },
  components: {},
  name: "AddEvent",
  mounted() {
    this.items = treeBuildCatList(this.items, this.tree);
  },
  data() {
    return {
      search: "",
      isSubmitting: false,
      selectedCategories: [],
      items: [],
      eventName: "",
    };
  },
  computed: {
    ...mapGetters({
      events: "getEventsGroupByRecord",
    }),
  },
  methods: {
    cancelDialog() {
      // Put up an "Are you sure?" dialog of some sort
      if (!window.confirm("Are you sure you want to cancel?")) {
        return;
      }
      this.$emit("cancel-add-dialog");
    },
    async submitChanges() {
      // Put up an "Are you sure?" dialog of some sort
      if (
        this.events[this.eventName] &&
        !window.confirm(
          `${this.eventName} already exists. Are you sure you want to replace it?`
        )
      ) {
        return;
      }
      this.isSubmitting = true;
      // Add this event name to all the selected nodes
      const promises = this.selectedCategories.map(async (item) => {
        return this.$store.dispatch("getRecordItemOnDemand", {
          recorditemid: item.id,
          recordid: this.selectedRecord._id,
        });
      });
      const nodes = await Promise.all(promises);
      nodes.forEach((item) => {
        if (Array.isArray(item.meta.events)) {
          const index = item.meta.events.indexOf(this.eventName);
          if (index === -1) {
            // Only add the event if it isn't already there
            item.meta.events.push(this.eventName);
          }
        } else {
          item.meta.events = [this.eventName];
        }
        this.updateEvent(item, this.selectedRecord._id);
      });
      this.$store.commit("UPDATE_EVENTS_GROUP", {
        event: this.eventName,
        members: nodes,
        recordId: this.selectedRecord._id,
      });
      this.isSubmitting = false;
      this.$emit("close-add-dialog");
    },
    async updateEvent(obj, root_id) {
      const payload = {
        obj,
        root_id,
      };
      const response = await this.$store.dispatch(
        "updateRecNode/updateRecordNode",
        payload
      );
    },
  },
};
</script>

<style scoped lang="scss">
.close-button {
  position: absolute;
  right: 0px;
  cursor: pointer;
  z-index: 200;
  margin-top: -10px;
}
.v-stepper__content {
  padding-top: 0;
}
.full-width {
  width: 100%;
}
</style>
